<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
  [queryParams]="queryParams"
></app-admin-header>
<section class="container-fluid v4-bg-img py-5">
  <div class="container ms-pg-structure">
    <div class="d-flex-between-mob-column" #scrollTarget>
      <div>
        <h4 class="large-h">
          {{ (isEdit ? "Update MS Session" : "Create MSSession") | translator }}
        </h4>
      </div>
    </div>

    <div class="white-box">
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>

      <div class="row my-4 justify-content-center">
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Name" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'MS Session Name' | translator"
              id="nameInput"
              aria-describedby="emailHelp"
              [(ngModel)]="sessionName"
            />
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Start Date" | translator }}</h5>
            <p-calendar
              class="form-control v4-border"
              [styleClass]="'calender-hide'"
              placeholder="dd/mm/yyyy"
              [minDate]="minDate"
              [(ngModel)]="startDate"
            ></p-calendar>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "End Date" | translator }}</h5>
            <p-calendar
              [minDate]="startDate"
              class="form-control v4-border"
              [styleClass]="'calender-hide'"
              placeholder="dd/mm/yyyy"
              [(ngModel)]="endDate"
            ></p-calendar>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-2">
        <button class="submmit-btn" (click)="createSession()">
          {{ (isEdit ? "Update MS Session" : "Create MSSession") | translator }}
        </button>
        <button *ngIf="isEdit" class="submmit-btn" (click)="cancelEdit()">
          {{ "Cancel" | translator }}
        </button>
      </div>
    </div>
    <div class="my-5">
      <h4 class="large-h mb-0">{{ "MSSession List" | translator }}</h4>
      <div *ngIf="sessions.length <= 0" class="mt-2">
        <app-no-data></app-no-data>
      </div>
      <ng-container *ngIf="sessions.length > 0">
        <div
          class="flex-white-box-row-mob white-box-row"
          *ngFor="let session of sessions; let i = index"
        >
          <div class="d-flex align-items-center mob-w-100">
            <div class="mobile-view">
              <div class="mob-w">
                <div class="number-box-session">
                  {{ i + 1 }}
                </div>
              </div>
              <div class="mob-w v4-my">
                <div *ngIf="session.name" class="detail-box">
                  {{ session.name }}
                </div>
                <div class="detail-box">
                  {{ formatDate(session.startDate) }}
                </div>
                <div class="detail-box">
                  {{ formatDate(session.endDate) }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div
              class="circle-btn"
              (click)="deleteSession(session._id, $event)"
            >
              <i class="fa fa-trash"></i>
            </div>
            <div class="circle-btn" (click)="loadSession(session)">
              <i class="fa fa-pencil"></i>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>
